import { useRoomContext } from '@livekit/components-react';
import { RoomEvent } from 'livekit-client';
import { useCallback, useEffect, useState } from 'react';

const useActiveDevice = kind => {
	const room = useRoomContext();
	const [activeDeviceId, setActiveDeviceId] = useState(() => room.getActiveDevice(kind) || '');

	useEffect(() => {
		const handleChanged = (changedKind, deviceId) => {
			if (changedKind === kind) {
				setActiveDeviceId(deviceId || '');
			}
		};

		setActiveDeviceId(room.getActiveDevice(kind) || '');

		room.on(RoomEvent.ActiveDeviceChanged, handleChanged);

		return () => {
			room.off(RoomEvent.ActiveDeviceChanged, handleChanged);
		};
	}, [room, kind]);

	const setActiveDevice = useCallback(
		deviceId => room.switchActiveDevice(kind, deviceId),
		[room, kind]
	);

	return { activeDeviceId, setActiveDevice };
};

export default useActiveDevice;
